import { UtilityService } from '@eforall/common';
import { GridColumn, buildColumn } from '@eforall/dashboard';
import { Opportunity } from '@interfaces';
import { AppService } from '../../../../../../services';


export function getColumns(util: UtilityService, app: AppService) {

	const columns: GridColumn<Opportunity, unknown>[] = [
		buildColumn(util, 'Id', row => row.opportunityId),
		// buildColumn(util, 'FullName', row => app.getStaffNameById(row.facilitatorId), { header: 'Name' }),
		// buildColumn(util, 'Text', row => app.staffDataMap().get(row.facilitatorId)?.email, { header: 'Email' }),
		// buildColumn(util, 'Text', row => row.accelerators, { header: 'Accelerators' }),
		buildColumn(util, 'DateTime', row => util.date.fromUTC(row.updatedUTC), { header: 'Updated', hidden: true }),
	];


	return columns;

}